var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"bg-overlay"},[_c('div',{staticClass:"bg-area-riservata"}),_vm._v(" "),_c('div',{staticClass:"bg-overlay-black"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4097fb01","hasScoped":true,"buble":{"transforms":{}}}!./src/component/area-riservata/area-riservata.html
// module id = 41
// module chunks = 0